import { Component, DestroyRef, effect, inject, ViewChild } from '@angular/core'
import { CustomerService } from '../../../../services/customer.service'
import { AuthenticationService } from '../../../../utilities/services/authentication.service'
import { User } from '../../../../utilities/models/user'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { FormsModule, NgForm } from '@angular/forms'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { NotificationService } from '../../../../utilities/services/notification.service'

@Component({
    selector: 'profile-modal',
    imports: [FormsModule],
    templateUrl: './profile-modal.component.html',
    styleUrl: './profile-modal.component.scss',
})
export class ProfileModalComponent {
    public readonly activeModal = inject(NgbActiveModal)
    private readonly customerService = inject(CustomerService)
    private readonly authenticationService = inject(AuthenticationService)
    private readonly destroyRef = inject(DestroyRef)
    private readonly notificationService = inject(NotificationService)
    
    keycloakId: string = ''
    customerInfo: any = {}
    
    @ViewChild('customerForm') customerForm!: NgForm

    constructor() {
        effect(() => {
            this.keycloakId = (this.authenticationService.user() as User).id
            this.getCustomerInfo()
        })
    }

    getCustomerInfo() {
        this.customerService.getCustomerById(this.keycloakId).subscribe((customer) => {
            this.customerInfo = customer
        })
    }

    saveIban(): void {
        if (!this.customerForm.valid) return;

        this.customerService
            .saveIban(this.keycloakId, this.customerInfo.iban)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: () => {
                    this.activeModal.close('refresh')
                    this.notificationService.showToast('La richiesta è stata salvata correttamente.', { type: 'success' })
                },
                error: () => this.notificationService.showToast('La richiesta non è andata a buon fine.', { type: 'danger' }),
            })
    }
}
